import Fuse from 'fuse.js';

const BASE_URL =
  '/api/collections/pages/entries/63548409-7c3d-4629-b7ce-52af0f64f220';

export default () => ({
  faq: null,
  results: [],
  query: '',
  searching: false,
  fuseOptions: {
    minMatchCharLength: 3,
    findAllMatches: true,
    threshold: 0.3,
    ignoreLocation: true,
    keys: ['answer', 'question'],
  },

  slugify(str) {
    str = str.replace(/^\s+|\s+$/g, '');
    str = str.toLowerCase();

    var from =
      'ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆĞÍÌÎÏİŇÑÓÖÒÔÕØŘŔŠŞŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇğíìîïıňñóöòôõøðřŕšşťúůüùûýÿžþÞĐđßÆa·/_,:;';
    var to =
      'AAAAAACCCDEEEEEEEEGIIIIINNOOOOOORRSSTUUUUUYYZaaaaaacccdeeeeeeeegiiiiinnooooooorrsstuuuuuyyzbBDdBAa------';
    for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str
      .replace(/[^a-z0-9 -]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');

    return str;
  },

  filter() {
    this.searching = true;
    this.results = [];
    this.faq.forEach((section) => {
      const fuse = new Fuse(section.questions, this.fuseOptions);
      const results = fuse.search(this.query);
      const resSection = {
        section_title: section.section_title,
        questions: results.map((question) => question.item),
      };
      if (results.length > 0) {
        this.results.push(resSection);
      }
    });
    const sections = this.results.map((item) => item.section_title);
    this.$dispatch('set-sidenav', sections);
    this.searching = false;
  },

  init() {
    fetch(BASE_URL)
      .then((response) => response.json())
      .then((response) => {
        this.faq = response.data.faq_sections;
      });
  },
});
